import {match} from 'ts-pattern';

import type {CustomerMessageResponseBody} from '@dms/api/core';

import type {
  InterestTimelineEvent,
  InterestTimelineEventKind,
} from '@prompt-bridge/shared/ai-assistant-core';

const toMessageKind = (channel: CustomerMessageResponseBody['channel']) =>
  match(channel)
    .returnType<InterestTimelineEventKind>()
    .with('email', () => 'email')
    .with('sms', () => 'sms')
    .with('whatsapp', () => 'message')
    .with('call', () => 'call')
    .exhaustive();

/**
 * A customer message is timeline evidence in its own right: inbound emails never become sales
 * activities, so without this the signal engine cannot see that a customer is waiting.
 * The message id doubles as the event id, which is how its text is matched back on.
 */
export const toInterestMessageTimelineEvent = (
  message: CustomerMessageResponseBody
): InterestTimelineEvent => ({
  id: message.id,
  occurredAt: message.createdAt,
  direction: message.direction === 'INCOMING' ? 'inbound' : 'outbound',
  kind: toMessageKind(message.channel),
});
